import { render } from "./generalData.vue?vue&type=template&id=9cb347d8"
import script from "./generalData.vue?vue&type=script&lang=js"
export * from "./generalData.vue?vue&type=script&lang=js"

import "./generalData.vue?vue&type=style&index=0&id=9cb347d8&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__